<template>
  <div class="wrapper">
    <canvas :id="id" :height="height"></canvas>
  </div>
</template>

<style scoped>
.wrapper {
  display: flex;
}
</style>
<script lang="ts">
import { Vue } from "vue-class-component";
import { ChartData, ChartOptions } from "chart.js";
import Chart from "chart.js/auto";
import { Prop } from "vue-property-decorator";

export default class LineChart extends Vue {
  chart!: Chart;
  @Prop({ type: String }) id = "chart";
  @Prop({ type: String }) height = "auto";
  @Prop({ type: Object }) chartData: ChartData = {
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        backgroundColor: "",
        borderColor: "",
        borderWidth: 1
      }
    ]
  };
  @Prop({ type: Object }) chartOptions: ChartOptions = {
    scales: {
      yAxes: {
        beginAtZero: true
      }
    }
  };
  renderChart() {
    let ctx = document.getElementById(this.id) as HTMLCanvasElement;
    this.chart = new Chart(ctx, {
      type: "line",
      data: this.chartData,
      options: this.chartOptions
    });
  }
  rerenderChart() {
    this.chart.destroy();
    this.renderChart();
  }
  mounted() {
    this.renderChart();
  }
}
</script>
